var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity-view-tabs"},_vm._l((_vm.items),function(itm){return _c('div',{class:_vm.itemClass(itm),on:{"click":function($event){return _vm.$emit('click', itm.key)}}},[_vm._v(_vm._s(itm.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }